import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const textColor = scrolled ? 'text-foreground-950' : 'text-background-50';
  const textHover = scrolled ? 'hover:text-foreground-700' : 'hover:text-background-50/80';
  const borderColor = scrolled ? 'border-background-200/70' : 'border-background-50/20';
  const pillBg = scrolled ? 'bg-primary-500 text-background-50' : 'bg-background-50 text-foreground-950';
  const pillHover = scrolled ? 'hover:bg-primary-600' : 'hover:bg-background-100';

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70' : 'bg-transparent'}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className={`font-heading font-bold text-xl whitespace-nowrap transition-colors ${textColor}`}>
            CSSBuySheet<span className={scrolled ? 'text-accent-500' : 'text-accent-400'}>.</span>
          </Link>

          <nav className="hidden md:flex items-center gap-7">
            <Link to="/" className={`text-sm font-medium transition-colors whitespace-nowrap ${textColor} ${textHover}`}>
              Início
            </Link>
            <Link to="/artigo/cssbuy-spreadsheet-guia-completo-2026" className={`text-sm font-medium transition-colors whitespace-nowrap ${textColor} ${textHover}`}>
              Guia Completo
            </Link>
            <a href="#categorias" className={`text-sm font-medium transition-colors whitespace-nowrap ${textColor} ${textHover}`}>
              Guia de Compras
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className={`text-sm font-medium transition-colors whitespace-nowrap ${textColor} ${textHover}`}>
              CSSBuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${pillBg} ${pillHover}`}
            >
              Buy It Now
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </a>
          </nav>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors ${textColor}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className={`md:hidden py-4 border-t ${borderColor}`}>
            <div className="flex flex-col gap-1">
              <Link to="/" className={`text-sm font-medium px-3 py-2.5 rounded-lg whitespace-nowrap transition-colors ${textColor} ${textHover}`} onClick={() => setMobileOpen(false)}>
                <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-home-line text-sm"></i>
                </span>
                Início
              </Link>
              <Link to="/artigo/cssbuy-spreadsheet-guia-completo-2026" className={`text-sm font-medium px-3 py-2.5 rounded-lg whitespace-nowrap transition-colors ${textColor} ${textHover}`} onClick={() => setMobileOpen(false)}>
                <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-file-text-line text-sm"></i>
                </span>
                Guia Completo
              </Link>
              <a href="#categorias" className={`text-sm font-medium px-3 py-2.5 rounded-lg whitespace-nowrap transition-colors ${textColor} ${textHover}`} onClick={() => setMobileOpen(false)}>
                <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-shopping-bag-3-line text-sm"></i>
                </span>
                Guia de Compras
              </a>
              <div className="border-t my-2" style={{ borderColor: scrolled ? 'oklch(var(--background-200))' : 'rgba(255,255,255,0.2)' }}></div>
              <p className="text-xs font-semibold px-3 py-1 uppercase tracking-wider" style={{ color: scrolled ? 'oklch(var(--foreground-500))' : 'rgba(255,255,255,0.5)' }}>
                Categorias
              </p>
              <div className="grid grid-cols-2 gap-1">
                {['Shoes','Hoodies/Sweaters','T-Shirts','Jackets','Pants/Shorts','Headwear','Sets','Underwear/Underpants','Jersey','Accessories','Bags','Belts','Perfumes','Other Stuff'].map((cat, i) => (
                  <a
                    key={cat}
                    href={`https://kaspreadsheet.com/${i === 0 ? 'category-911-Shoes.html' : `search-${911 + i}/name/Shoes.html`}`}
                    target="_blank"
                    rel="noopener nofollow"
                    className={`text-xs px-3 py-2 rounded-lg whitespace-nowrap transition-colors ${textColor} ${textHover}`}
                    onClick={() => setMobileOpen(false)}
                  >
                    {cat}
                  </a>
                ))}
              </div>
              <div className="border-t my-2" style={{ borderColor: scrolled ? 'oklch(var(--background-200))' : 'rgba(255,255,255,0.2)' }}></div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className={`inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer mx-3 ${pillBg} ${pillHover}`}
              >
                Buy It Now
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-xs"></i>
                </span>
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}